import { Component } from '@angular/core';
import { register } from 'swiper/element/bundle';
import { MetricasService } from './services/metricas.service';
register();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.less',
    standalone: false
})
export class AppComponent {
  title = 'portal-cliente';

  constructor(private metricas: MetricasService) {
    this.metricas.init();
  }
}
